import { useModal, ButtonColor } from '@ampol/design-system';

interface ConfirmReplacementCardModalProps {
  status: string;
  cardsList: string[];
  onStatusOnlyUpdate: () => void;
  onReplaceCard: () => void;
}

const useConfirmReplacementCardModal = (
  props: ConfirmReplacementCardModalProps
) => {
  const plural = props.cardsList.length > 1 ? 's' : '';

  const modal = useModal({
    color: ButtonColor.Blue,
    title: `Would you like to replace the card${plural}?`,
    id: 'confirm-replacement-card-modal',
    variant: 'double',
    content: (
      <p>
        {`You've set your card status to ${props.status}. Would you like to replace the card${plural}?`}
      </p>
    ),
    actions: [
      {
        label: `Yes, replace card${plural}`,
        onClick: () => props.onReplaceCard(),
      },
      {
        label: 'No, only change status',
        onClick: () => props.onStatusOnlyUpdate(),
      },
    ],
  });

  return modal;
};

export default useConfirmReplacementCardModal;
